if (!customElements.get('details-shop-by-needs')) {
    customElements.define(
        'details-shop-by-needs',
        class extends HTMLElement {
            constructor() {
                super();
                this.swiperEl = this.querySelector('.details-shop-by-needs__swiper .swiper');
                this.buttons = this.querySelectorAll('.details-shop-by-needs__card');
                this.scene = this.querySelector('.details-shop-by-needs__swiper');
            }

            connectedCallback() {
                this.initSwiper();
                this.clickFunction();
                this.checkUrlParam();
            }

            initSwiper() {
                this.swiper = new Swiper(this.swiperEl, {
                    allowTouchMove: false,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true,
                    },
                    autoHeight: true,
                })
            }

            clickFunction() {
                // 事件委托 this
                this.addEventListener('click', (e) => {
                    const card = e.target.closest('.details-shop-by-needs__card');
                    if (!card || !this.contains(card)) return;

                    // 如果当前点击的已是激活态则直接返回
                    if (card.classList.contains('active')) return;

                    // 在这里添加ScrollToView，滚动到this.scene可见区域，但是需要考虑<html>中的2个css变量：--announcement-bar-height和--header-height，计算置顶元素的高度
                    if (this.scene) {
                        const rootStyles = getComputedStyle(document.documentElement);
                        const annBar = parseFloat(rootStyles.getPropertyValue('--announcement-bar-height')) || 0;
                        const header = parseFloat(rootStyles.getPropertyValue('--header-height')) || 0;
                        const offset = annBar + header;

                        const rect = this.scene.getBoundingClientRect();
                        const targetTop = rect.top + window.scrollY - offset;

                        window.scrollTo({
                            top: Math.max(0, targetTop) - 50, // 减去50px，使置顶元素稍微在视口上方
                            behavior: 'smooth',
                        });

                        const url = new URL(window.location.href);
                        url.searchParams.set('data-index', card.dataset.index);
                        window.history.replaceState({}, '', url);
                    }

                    // 移除其他按钮的激活态
                    this.buttons.forEach((button) => {
                        if (button !== card) button.classList.remove('active');
                    });

                    // 获取索引并滑动到对应幻灯片（Swiper 使用 0 基）
                    const idx = Number(card.dataset.index);
                    if (!Number.isNaN(idx) && this.swiper) {
                        this.swiper.slideTo(idx - 1);
                    }

                    // 当前按钮设为激活态
                    card.classList.add('active');
                })
            }

            checkUrlParam() {
                // 定义urlParam为目前url中的data-index参数
                const urlParam = new URLSearchParams(window.location.search).get('data-index');
                if (urlParam) {
                    // 如果urlParam存在，则获取对应的按钮并触发点击事件
                    const button = this.querySelector(`.details-shop-by-needs__card[data-index="${urlParam}"]`);
                    if (button) {
                        button.click();
                    }
                } else {
                    // 如果urlParam不存在，则默认添加第一个按钮的参数
                    const url = new URL(window.location.href);
                    url.searchParams.set('data-index', this.buttons[0].dataset.index);
                    window.history.replaceState({}, '', url);
                }
            }
        }
    );
}